/* ==========================================================================
   Contact Sales Page
   Cal.com iframe embed for scheduling sales demo calls
   ========================================================================== */

import { Link } from 'react-router-dom'
import { Calendar } from 'lucide-react'
import { MarketingLayout } from '@/components/layout/MarketingLayout'

const CAL_EMBED_URL =
  'https://cal.com/clark.hawkins/tjm-labs-website-demo?embed=true&layout=month_view&hideBranding=true'

const nav = (
  <>
    <a
      href="/#pricing"
      className="text-sm text-charcoal hover:text-deep-purple transition-colors"
    >
      Pricing
    </a>
    <Link
      to="/admin/login"
      className="text-sm text-deep-purple hover:underline font-medium"
    >
      Login
    </Link>
  </>
)

export function ContactSales() {
  return (
    <MarketingLayout nav={nav}>
      <main className="py-12 sm:py-16">
        {/* Value prop — narrower for readability */}
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-soft-lavender mb-6">
            <Calendar className="h-7 w-7 text-deep-purple" aria-hidden="true" />
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl text-charcoal mb-4">
            Let's Get Your Portal Set Up
          </h1>
          <p className="text-base sm:text-lg text-charcoal/70 max-w-xl mx-auto">
            Schedule a call with our team. We'll walk you through the
            platform, help you choose the right plan, and have your branded
            portal live within days.
          </p>
        </div>

        {/* Cal.com iframe embed */}
        <div className="max-w-6xl mx-auto px-2 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)] overflow-hidden mb-8">
            <iframe
              src={CAL_EMBED_URL}
              title="Schedule a demo with Clark Hawkins"
              className="w-full border-0"
              style={{ minHeight: '680px', height: '100%' }}
              loading="lazy"
            />
          </div>

          {/* Email fallback (always shown) */}
          <div className="text-center">
            <p className="text-sm text-charcoal/50">
              Prefer email?{' '}
              <a
                href="mailto:sales@tjmlabs.com"
                className="text-deep-purple hover:underline"
              >
                sales@tjmlabs.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </MarketingLayout>
  )
}

export default ContactSales
